import icon from './sentiment.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

angular
    .module('MW.InsDashboard.SentimentWidget',[
        'MW.InsDashboard.insightsBackendService',
        'MW.Dashboard.DashboardWidgetService',
        'DashboardChartConfigService',
        'CoreChartObject',
        'MW.Framework.TranslationService',
        'MW.Framework.GeoService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.CoreCommon',
        'MW.InsDashboard.ChartDataService',
        'MW.InsDashboard.InsightsDataMaps',
        'MW.InsDashboard.TransformSentiment',
        'MW.Framework.CoreBreadcrumb',
        'MW.Dashboard.DashboardStateService',
        'MW.Framework.AppChromeService',
        'MW.Configuration'
        ])
    .directive('sentimentWidget', ['insightsBackendService', 'DashboardWidgetService', '$filter', 'DashboardChartConfigService','CoreChartObject', 'translationService', 'GeoService', 'InsWidgetConfigService', 'CoreCommon', 'ChartDataService', 'InsightsDataMaps', 'TransformSentiment', '$routeParams', '$location', 'Breadcrumb', 'DashboardStateService', function(insightsBackendService, DashboardWidgetService, $filter, DashboardChartConfigService,CoreChartObject, translationService, GeoService, InsWidgetConfigService, CoreCommon, ChartDataService, InsightsDataMaps, TransformSentiment, $routeParams, $location, Breadcrumb, DashboardStateService){

    var sentimentWidget = DashboardWidgetService.getWidget('sentiment-widget');

    var sentimentWidgetController = function($scope){
        $scope.insightsService = 'statisticService';
        $scope.insightsObject = 'dateSentimentHistograms';
        $scope.initSettings = function(){
            InsWidgetConfigService.readyWidgetData($scope);
        };
    };

    var sentimentWidgetLink = function(scope, element) {

        var getLabelFormatFromSettings = function getLabelFormatFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.labelFormat) ? scope.widget.settings.labelFormat[0].id : scope.widget.availableLabelFormat[0].id;
        };

        var getDateBreakoutsFromSettings = function getDateBreakoutsFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.dateBreakouts) ? scope.widget.settings.dateBreakouts[0].id : scope.widget.availableDateBreakouts[0].id;
        };

        scope.widget.settings.chart = {
            xAxisType: "category",
            yAxisAbs: true
        };

        var getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.labelVisibility) ? scope.widget.settings.labelVisibility[0].id : scope.widget.availableLabelVisibility[0].id;
        };
        scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;

        scope.selectedLabelFormatId = getLabelFormatFromSettings(); // Getting Label Format id from widget.settings

        if(scope.selectedLabelFormatId == 1) { // Number
            scope.widget.settings.chart.percentageMode = false;
        } else if (scope.selectedLabelFormatId == 2) { // Percentage
            scope.widget.settings.chart.percentageMode = true;
        }

        scope.selectedDateBreakoutsId = getDateBreakoutsFromSettings(); // Getting Date Breakouts Id from widget.settings

        scope.dateBreakoutsDay = (scope.selectedDateBreakoutsId === 'DAY')? true : false;
        scope.dateBreakoutsWeek = (scope.selectedDateBreakoutsId === 'WEEK')? true : false;
        scope.dateBreakoutsMonth = (scope.selectedDateBreakoutsId === 'MONTH')? true : false;
        scope.dateBreakoutsQuarter = (scope.selectedDateBreakoutsId === 'QUARTER')? true : false;
        scope.dateBreakoutsYear = (scope.selectedDateBreakoutsId === 'YEAR')? true : false;

        scope.widgetIsLoading = false;
        scope.noDataFromServer = false;
        scope.notConfigured = false;
        scope.serviceError=false;
        scope.fetching = false;
        scope.showTable = false;
        scope.documentRequest = {};

        scope.graphType =  CoreCommon.isUsable(scope.widget.settings.selectedGraphType)?scope.widget.settings.selectedGraphType.id : scope.widget.getDefaultChartType().id;

        // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
        scope.$on('widgetFiltersUpdated', function() { scope.fetchData(true) });

        scope.fetchData = function(isExternal) {
            var getChart = function(){
                scope.widgetIsLoading=false;
                scope.chart = {};

                var doChartAnimation = InsWidgetConfigService.getChartAnimationStatus(scope.widget.id+scope.isMaximized);

                if(scope.graphType === 'table') {
                    scope.tableSettings.drilldown = function drilldown(datapoint) {
                        scope.documentRequest['sentiment'] = datapoint.sentimentType;
                        if(typeof scope.inputs !== 'undefined'){
                            scope.internalDrillDown(scope.inputs[0].id, this.date);
                        } else {
                            scope.internalDrillDown(scope.searches[0].agent, this.date);
                        }
                    };
                    scope.tableSettings.tooltip = function tooltip(datapoint) {
                        return translationService.getLocalizedString('Sentiments') + ': ' + datapoint.sentimentCount;
                    };
                    scope.showTable = true;
                } else if(scope.graphType === 'donut' || scope.graphType === 'pie') {
                    var customData = {
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true,
                                    formatter: function() {
                                        var label = '';
                                        if(scope.widget.settings.chart.percentageMode) {
                                            label = DashboardChartConfigService.formatDataLabels(this.percentage).toFixed(2) + '%';
                                        } else {
                                            label = DashboardChartConfigService.formatDataLabels(this.y);
                                        }
                                        if(scope.labelVisibility) {
                                            return this.point.name + ': ' + label;
                                        } else {
                                            return this.point.name;
                                        }
                                    }
                                },
                                point: {
                                    events: {
                                        click: function() {
                                            scope.documentRequest['sentiment'] = this.sentiment;
                                            if(typeof scope.inputs !== 'undefined'){
                                                scope.internalDrillDown(scope.inputs[0].id, this.date);
                                            } else {
                                                scope.internalDrillDown(scope.searches[0].agent, this.date);
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    };
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, customData);
                } else {
                    scope.customData = {
                        yAxis: {
                            min: scope.graphType === 'spline' ? 0 : null,
                            floor: (scope.graphType === 'column' && scope.widget.settings.chart.percentageMode) ? -100 : null
                        },
                        legend: {
                            enabled: true
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    style: {
                                        color: '#000'
                                    },
                                    enabled: scope.labelVisibility,
                                    formatter: function() {
                                        if(scope.widget.settings.chart.percentageMode) {
                                            return DashboardChartConfigService.formatDataLabels(this.y) + '%';
                                        } else {
                                            return DashboardChartConfigService.formatDataLabels(this.point.count);
                                        }
                                    }

                                },
                                animation: doChartAnimation,
                                point: {
                                    events: {
                                        click: function() {
                                            scope.documentRequest['sentiment'] = this.series.name;
                                            if(typeof scope.inputs !== 'undefined'){
                                                scope.internalDrillDown(scope.inputs[0].id, this.date);
                                            }else {
                                                scope.internalDrillDown(scope.searches[0].agent, this.date);
                                            }
                                        }
                                    }
                                },
                                stacking: scope.graphType === 'column' ? 'normal' : null

                            }
                        },
                        tooltip: {
                            /* for tooltip over other bars */
                            hideDelay: 0,
                            formatter: tooltipHandler
                        }
                    };
                    if(!scope.isMaximized){
                        scope.customData.xAxis = DashboardChartConfigService.getDashboardXAxisObject(scope.chartData.xAxis.categories);
                    }

                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, scope.customData);
                }
            }

            isExternal = isExternal || false;
            scope.initSettings();
            if(!scope.readyToQuery)
                return;

            if (isExternal){
                scope.graphType = scope.widget.settings.selectedGraphType.id || scope.graphType;
                if(scope.graphType != 'table'){
                    scope.highchart = true;
                }
            }

            scope.widgetIsLoading=true;
            scope.serviceError = false;
            scope.noDataFromServer = false;
            scope.notConfigured = false;

            scope.chartDataObject.dataMap = InsightsDataMaps.datamapDateSentiment;
            scope.chartDataObject.percent = scope.widget.settings.chart.percentageMode;
            scope.chartDataObject.chartTransformFunction = TransformSentiment[scope.graphType];
            if(scope.graphType == 'table') {
                scope.chartDataObject.callback = function(tableRequestData) {
                    scope.tableSettings.data = tableRequestData.table;
                    if(scope.widget.settings.chart.percentageMode === true){
                        scope.tableSettings.summary = tableRequestData.percentSummary;
                        scope.tableSettings.displayField = scope.tableSettings.percentField;
                    } else {
                        scope.tableSettings.summary = tableRequestData.countSummary;
                        scope.tableSettings.displayField = scope.tableSettings.countField;
                    }
                    getChart();
                }
            } else {
                scope.chartDataObject.callback = function(chartRequestData) {
                    scope.chartData = {};
                    var viewName = 'user';
                    if(scope.isReport){
                        viewName = 'report';
                    } else if(scope.isMaximized){
                        viewName = 'max';
                    }
                    var chartBasics = {
                        type: scope.graphType,
                        view: viewName,
                        percent: scope.widget.settings.chart.percentageMode,
                        yAxisAbs: false,
                        reportType: scope.reportType
                    };

                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, chartRequestData);
                    scope.chartData = new CoreChartObject(chartBasics, scope.chartData);
                    checkRoutes();
                    getChart();
                };
            }
            //URL sharing on widgets for correct chart
            delete scope.chartDataObject.queryParameters.sentiment;
            scope.chartDataObject.queryParameters.dateStart = scope.chartDataObject.fromDate;
            scope.chartDataObject.queryParameters.dateEnd = scope.chartDataObject.toDate;

            ChartDataService.fetchAllData(scope.chartDataObject, scope.$id).catch(function onCatch(error) {
                scope.$emit('chartData_fetchAllDataError', error);
            });
        };

        var checkRoutes = function checkRoutes() {
            if($routeParams.sentiment || $routeParams.date) {
                updateBreadcrumb($routeParams.sentiment, $routeParams.date);
            }
        };

        var tooltipHandler = function(event){
            var output;
            output = translationService.getLocalizedString('Count') + ': ';
            output += Highcharts.numberFormat(this.point.count, 0);
            output += '<br />' + translationService.getLocalizedString('Percentage') + ': ' + Highcharts.numberFormat(this.point.perc, 0) + '%';

            return output;
        };

        if(scope.widget.hasRequiredSettings()){
            scope.fetchData();
        }
        else scope.notConfigured=true;

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var newParams = getRequestparams(newVal),
                oldParams = getRequestparams(oldVal),
                displayDate;

            if(newParams.date) {
                //correctly parsing the '+' character in encoded date in newParams
                newParams.date = newParams.date.replace(/(%2B)/g, '+');
            }
            updateBreadcrumb(newParams.sentiment, newParams.date);

            if(oldParams.sentiment !== undefined && newParams.sentiment === undefined) {
                if(scope.documentRequest.sentiment) {
                    delete scope.documentRequest.sentiment;
                }
                if(InsWidgetConfigService.queryRequestSettings.sentiment){
                    InsWidgetConfigService.queryRequestSettings.sentiment = null;
                }
                InsWidgetConfigService.dateGranularityDrilldown(false, undefined, scope);
            } else if((newParams.sentiment !== undefined && oldParams.sentiment === undefined) || (newParams.sentiment !== undefined && oldParams.sentiment !== undefined && ((newParams.sentiment !== oldParams.sentiment) || (newParams.date !== oldParams.date)))) {
                // In this case, the user probably used the browser's Forward button to go back to a drilldown.
                // Since we don't have the benefit of a click trigger, we need to do it manually here
                scope.documentRequest['sentiment'] = newParams.sentiment;
                if(typeof scope.inputs !== 'undefined'){
                    scope.drillDown(scope.inputs[0].id, newParams.date, scope);
                } else {
                    scope.drillDown(scope.searches[0].agent, newParams.date, scope);
                }
            }

            if (newVal.indexOf('&drilled&') > -1) {
                if(newParams.date) {
                    displayDate = moment(newParams.date.split('T')[0]);
                    breadcrumbString = scope.breadcrumbs[scope.breadcrumbs.length - 1].name;
                    breadcrumbArray = breadcrumbString.split(',');
                    if (scope.dateBreakoutsMonth) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.format("MMM") + ' ' + displayDate.year());
                    }
                    else if (scope.dateBreakoutsQuarter) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', Q' + displayDate.quarter() + ' ' + displayDate.year());
                    }
                    else if (scope.dateBreakoutsYear) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.year());
                    }
                }
            }
        });

        var updateLastBreadcrumb = function updateLastBreadcrumb(lastBreadcrumb) {
            scope.breadcrumbs[scope.breadcrumbs.length - 1].name = lastBreadcrumb;
        };

        var getRequestparams = function getRequestparams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        };

        scope.internalDrillDown = function(id, date){
            var sentimentCode = scope.documentRequest.sentiment;

            if(scope.isMaximized) {
                var queryParams = {
                    drilled: true
                };
                if(sentimentCode) {
                    queryParams['sentiment'] = sentimentCode;
                }
                if(date) {
                    queryParams['date'] = $filter('mwConvertDateToUserTimezone')(date);
                }

                updateLocationURL(queryParams);
            }
            scope.drillDown(id,date,scope);
            if(scope.graphType !== 'table') {
                scope.$apply();
            }
        };

        var updateLocationURL = function updateLocationURL(queryParams) {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            var urlQuery = {
                editMode:editMode
            };
            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop]
            }
            updateBreadcrumb(queryParams.sentiment, queryParams.date);
            $location.path(maxPath).search(urlQuery);
        };

        var updateBreadcrumb = function updateBreadcrumb(sentimentCode, date) {
            var dashboardPath,
            widgetPath,
            selectionTitle = '',
            dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

            scope.breadcrumbs =[];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];
            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;
            scope.breadcrumbs.push(Breadcrumb.build({name:scope.dashboard.title, link:dashboardPath }));

            if(sentimentCode) {
                switch(sentimentCode) {
                    case 'P':
                        selectionTitle += translationService.getLocalizedString('Positive');
                        break;
                    case 'V':
                        selectionTitle += translationService.getLocalizedString('Negative');
                        break;
                    case 'N':
                        selectionTitle += translationService.getLocalizedString('Neutral');
                }
            }

            selectionTitle += date ? ', ' + $filter('mwConvertDateToUserTimezone')(date, 'MMM Do') : '';

            if(selectionTitle === '') {
                var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                   subCrumbs = [],
                   myNewPath,
                   subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, subCrumbs:subCrumbs}));
            } else {
                widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, link: widgetPath}));
                scope.breadcrumbs.push(Breadcrumb.build({name:selectionTitle}));
            }
        };

        scope.drillDown= InsWidgetConfigService.dateGranularityDrilldown;

        scope.togglePercentage = function(id) {
            var oldMode = scope.widget.settings.chart.percentageMode,
                mode;
            scope.selectedLabelFormatId = id;
            if(id === 1) {
                mode = false;
            } else if (id === 2) {
                mode = true;
            }
            scope.widget.settings.chart.percentageMode = mode;
            if (oldMode !== scope.widget.settings.chart.percentageMode)
                scope.fetchData();
        };

        scope.toggleGraph = function(graphType) {
            //on toggle we do not want existing click filter to be applied
            if(InsWidgetConfigService.queryRequestSettings.sentiment){
                InsWidgetConfigService.queryRequestSettings.sentiment = null;
            }
            InsWidgetConfigService.queryRequestSettings.dateStart = scope.chartDataObject.fromDate;
            InsWidgetConfigService.queryRequestSettings.dateEnd = scope.chartDataObject.toDate;
            var oldGraphType = scope.graphType;
            scope.graphType = graphType;
            //if (oldGraphType != graphType) {
                scope.showTable = false;
           // }
            resetBreadcrumb()
            scope.fetchData();
            scope.initSettings();
        };

        scope.toggleTable = function() {
            //on toggle we do not want existing click filter to be applied
            if(InsWidgetConfigService.queryRequestSettings.sentiment){
                InsWidgetConfigService.queryRequestSettings.sentiment = null;
            }
            InsWidgetConfigService.queryRequestSettings.dateStart = scope.chartDataObject.fromDate;
            InsWidgetConfigService.queryRequestSettings.dateEnd = scope.chartDataObject.toDate;
            scope.graphType = 'table';
            resetBreadcrumb();
            scope.fetchData();
        };

        var resetBreadcrumb = function resetBreadcrumb() {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            var urlQuery = {
                editMode:editMode
            };

            updateBreadcrumb();
            $location.path(maxPath).search(urlQuery);
        }

        scope.tableSettings = {
            enabled: true,
            data: {},
            rowTitle: translationService.getLocalizedString('Sentiment'),
            summaryTitle: translationService.getLocalizedString('Total'),
            countField: 'sentimentCount',
            percentField: 'sentimentPercent',
            titleField: 'name'
        };
    };

    return new WidgetDirective(sentimentWidget, sentimentWidgetLink, sentimentWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'CoreCommon', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService, CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Sentiment'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Sentiment widget gives insight into how coverage is broken ' +
            'down by positive and negative sentiment over time for one brand, ' +
            'product, event or topic. The widget is useful for easily being ' +
            'able to identify spikes in sentiment and subsequently access content ' +
            'of interest by a click of a button. The widget works best using one input.'),
        directive: 'sentiment-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            source: [],
            'maxAgents': 1
        },
        displayOrder: 3,
        allowExport: true,
        availableFilters : [{name:'Country',id:'country'},{name:'Language',id:'language'}],
        availableSettings: ['dateRange', 'title', 'news', 'social','broadcast', 'tags', 'chartType', 'labelFormat', 'dateBreakouts', 'labelVisibility'],
        availableChartTypes:[
            {name:'Line',id:'spline'},
            {name:'Bar',id:'column'},
            {name:'Donut',id:'donut'},
            {name: 'Pie', id: 'pie'}],
        requiredSettings: ['dateRange'],
        getDefaultChartType: function() {
            if (CoreCommon.isUsable(this.settings.searchIds) && this.settings.searchIds.length > 1)
                return this.availableChartTypes[0];
            else
                return this.availableChartTypes[1];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
